import Cookies from 'js-cookie';

export function appendAvtToUrl(url: string): string {
  const savt = Cookies.get('_savt');
  let avtUrl;

  try {
    avtUrl = new URL(url);
  } catch (e) {
    console.error(`Invalid url: ${url}`, e);
    return url;
  }

  if (savt && !avtUrl.searchParams.get('_avt')) {
    avtUrl.searchParams.set('_avt', savt);
  }

  return avtUrl.toString();
}
